import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import App from './components/App';
import CreateStore from './store/Store';
import { getScreen } from './actions/screenAction';
import './css/styles.css';
import './css/reset.css';
import '../node_modules/bango.keshiki/build/payment-flow/payment-flow.css';
import VivoComponents from './components/ScreenComponents/VivoComponents';

const store = CreateStore();
store.dispatch(getScreen());
render(
  <Provider store={store}>
    <App additionalScreens={VivoComponents} />
  </Provider>,
document.getElementById('root')
);


/** WEBPACK FOOTER **
 ** ./src/index.vivo.js
 **/